export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";